<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Store</h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :page="currentPage"/>
          <link-button
              v-if="currentRole === 'seller'"
              :to="{name: 'createStore'}"
              :classes="['btn-info', 'd-block', 'ml-lg-3', 'm-l-15']"
          >
            <i class="fa fa-plus-circle"/>
            Create Store
          </link-button>
        </div>
      </div>

    </div>
    <loading-container :loading="loading">
      <div v-if="!list || list.length == 0" class="text-center">
        No store found
      </div>
      <div v-else class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="table-responsive">
              <table class="table table-striped no-footer">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Date created</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(store, index) in list"
                    :class="index % 2 == 0 ? 'odd' : 'even'"
                    :key="store.id"
                >
                  <td>
                    <span>{{ store.id }}</span>
                  </td>
                  <td>
                    <router-link :to="{ name: 'storeDetail', params: { storeId: store.id }}">
                      {{ store.name }}
                    </router-link>
                  </td>
                  <td>
                    <span>{{ store.type }}</span>
                  </td>
                  <td>
                    <span>{{ store.updatedAt | dateDisplay }}</span>
                  </td>
                  <td>
                    {{ store.status }}
                  </td>
                  <td>
                    <div>
                      <button type="button" class="btn btn-secondary" title="Delete store"
                              @click="() => openWarning(store.id)">
                        <i class="ti-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 d-flex justify-content-center">
          <pagination
              :routeName="routeName"
              :query="search"
              :current="page"
              :total="total"
          />
        </div>
      </div>
      <modal
          :show="form.showDeleteConfirm"
          title="Warning"
          :close="() => setField({ key: 'showDeleteConfirm', value: false })"
      >
        <h2 class="swal2-title" id="swal2-title" style="display: flex;">Are you sure to delete?</h2>
        <div slot="footer">
          <div slot="footer">
            <div class="flex-group">
              <button type="button" class="btn btn-danger mr-1 flex-item" @click="() => deleteStore()">
                <span v-if="loading">
                  <i class="fa fa-spin fa-spinner"/>
                </span>
                <span v-else>
                  Sure
                </span>
              </button>
              <button type="button" class="btn btn-secondary flex-item"
                      @click="() => setField({ key: 'showDeleteConfirm', value: false })">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </modal>
    </loading-container>
  </div>
</template>


<script>
import {mapActions, mapGetters} from "vuex";

import LoadingContainer from "@/components/Misc/LoadingContainer";
import InputSelect from "@/components/Form/InputSelect";
import InputText from "@/components/Form/InputText";
import Pagination from "@/components/Misc/Pagination";
import LinkButton from "@/components/Misc/LinkButton";
import FormButton from "@/components/Form/FormButton";
import Breadcrumb from "@/components/Common/Breadcrumb";
import Modal from "@/components/Misc/Modal";

export default {
  name: "ListStore",
  components: {
    LoadingContainer,
    InputSelect,
    Pagination,
    LinkButton,
    InputText,
    FormButton,
    Breadcrumb,
    Modal
  },
  beforeMount() {
    const query = this.$route.query;
    const page = query.page ? parseInt(query.page) : 1;
    const status = query.status;

    this.getListStore({page, search: {status}});
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      list: "store/list",
      search: "store/search",
      loading: "store/loading",
      count: "store/count",
      total: "store/total",
      page: "store/page",
      form: "store/form",
      error: 'store/error',
    }),
    statusOptions() {
      return [
        {value: "type", text: "Type"},
        {value: "name", text: "Name"},
        {value: "createdAt", text: "Created"}
      ];
    },
    routeName() {
      return this.$router.name;
    },
    currentPage() {
      return this.$store.state.route.meta.title;
    },
    currentUser() {
      return this.user || {};
    },
    currentRole() {
      return this.currentUser.role;
    },
  },
  methods: {
    ...mapActions({
      getListStore: "store/getListStore",
      deleteStore: "store/deleteStore",
      setField: "store/setField",
    }),
    openWarning(id) {
      this.setField({key: 'showDeleteConfirm', value: true});
      this.setField({key: 'id', value: id});
    },
  }
};
</script>
